var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentEditable',{attrs:{"data-item-id":_vm.itemId,"data-item-type":"PageText","div-style":_vm.textStyle},model:{value:(_vm.data.text),callback:function ($$v) {_vm.$set(_vm.data, "text", $$v)},expression:"data.text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }